import { PocetnaAdministrativnaPage } from "@/pages/PocetnaAdministrativnaPage";
import { PocetnaKadrovskaPage } from "@/pages/PocetnaKadrovskaPage";
import { PocetnaUpravaPage } from "@/pages/PocetnaUpravaPage";
import { PocetnaVoditeljPage } from "@/pages/PocetnaVoditeljPage";
import { useAuth } from "@/context/AuthContext";
import { ProcurementHomeTiles } from "@/components/nabava/OrderShared";
import { ReceivedInvoiceHomeTile } from "@/components/nabava/ReceivedInvoiceHomeTile";

/**
 * The home screen depends on the job, not on a setting.
 *
 * A site manager holds `sati:create` and reaches workers through the roster;
 * personnel hold the register. Choosing by permission rather than by role code
 * keeps this working when somebody holds both, and keeps role names out of the
 * interface logic — the matrix is data, and this must not become a second
 * place where it is decided.
 *
 * The personnel dashboard is no longer the fallback. It asks for the whole
 * register on mount, so it was the wrong landing place for an account that may
 * not read one worker — a technical administrator under O-11 saw a failed
 * screen instead of a home screen. What both business screens need is a read
 * over workers, in either scope: `radnik.osnovno:read` is what the API checks,
 * and `radnik:read` is the wider grant that implies it.
 */
export function PocetnaPage() {
  const { can } = useAuth();

  const vidiRadnike = can("radnik.osnovno", "read") || can("radnik", "read");
  const tiles = <><ReceivedInvoiceHomeTile /><ProcurementHomeTiles /></>;

  if (can("djelatnik", "blokada_override")) {
    return <>{tiles}<PocetnaUpravaPage /></>;
  }
  if (!vidiRadnike && !can("sati", "create")) {
    return <>{tiles}<PocetnaAdministrativnaPage /></>;
  }
  if (can("sati", "create") && !can("radnik", "read")) {
    return <>{tiles}<PocetnaVoditeljPage /></>;
  }
  return <>{tiles}<PocetnaKadrovskaPage /></>;
}
